import request from '../../request';
import { URL } from '../../../constants/shared/ApiConstants';

class IntercomClient {
    static getUserHash = () => request.get(URL.INTERCOM_USER_HASH_URL);
}

export default IntercomClient;
